import { createSystem, defaultConfig, mergeConfigs } from '@chakra-ui/react';
import { buildBaseTheme } from '../ThemeGen/exports';

const baseTheme = buildBaseTheme({
  primaryColor: '#83151e',
  secondaryColor: '#4F6D7A',
  tertiaryColor: '#C9A227',
  buttons: {
    borderRadius: 10
  }
});

const merged = mergeConfigs(defaultConfig, baseTheme);
export default createSystem(merged);
